import React, { useState, useEffect, useRef } from 'react';
// import logo from '../assets/logo.png';
// import jyotinay_analytics_logo from '../assets/jyotinay_analytics_logo.png'
import { Link } from 'react-router-dom';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const menuRef = useRef(null);
    const servicesRef = useRef(null);

    // const location = useLocation();
    // const navigate = useNavigate();

    // You can set here which routes have anchors
    // const hasAnchors = location.pathname === '/' || location.pathname === '/services';

    // Helper to handle smooth scroll or navigate
    // const handleScrollOrNavigate = (sectionId, path = '/') => {
    //     if (location.pathname === path) {
    //         // Same page, smooth scroll
    //         const el = document.getElementById(sectionId);
    //         if (el) {
    //             el.scrollIntoView({ behavior: 'smooth' });
    //             setIsMenuOpen(false); // close menu on mobile if open
    //         }
    //     } else {
    //         // Navigate to the page with hash
    //         navigate(`${path}#${sectionId}`);
    //         setIsMenuOpen(false); // close menu on mobile if open
    //     }
    // };

    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (menuRef.current && !menuRef.current.contains(event.target)) {
    //         setIsMenuOpen(false);  // 👈 uses your existing state
    //         }
    //     };

    //     document.addEventListener('mousedown', handleClickOutside);
    //     return () => {
    //         document.removeEventListener('mousedown', handleClickOutside);
    //     };
    // }, []);


    // useEffect(() => {
    //     const handleClickOutside = (e) => {
    //     if (
    //         servicesRef.current &&
    //         !servicesRef.current.contains(e.target)
    //     ) {
    //         setIsServicesOpen(false);
    //     }
    //     }

    //     if (isServicesOpen) {
    //     document.addEventListener("mousedown", handleClickOutside);
    //     } else {
    //     document.removeEventListener("mousedown", handleClickOutside);
    //     }

    //     // cleanup when component unmounts or dropdown closes
    //     return () => {
    //     document.removeEventListener("mousedown", handleClickOutside);
    //     };
    // }, [isServicesOpen]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            const clickedOutsideMenu =
            menuRef.current && !menuRef.current.contains(event.target);
            const clickedOutsideServices =
            servicesRef.current && !servicesRef.current.contains(event.target);

            // If clicked outside BOTH, close both dropdowns
            if (clickedOutsideMenu && clickedOutsideServices) {
            setIsMenuOpen(false);
            setIsServicesOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (
        <div className="w-full bg-white bg-opacity-90 backdrop-blur-sm border-b border-gray-200 fixed top-0 z-50">
            <div className="container mx-auto flex items-center justify-between" ref={menuRef}>
                {/* Logo */}
                {/* <Link to="/" onClick={() => window.scrollTo(0, 0)}>
                    <img
                        src={jyotinay_analytics_logo}
                        alt="Logo"
                        className="h-16 sm:h-24 lg:h-24 mx-8 drop-shadow-md cursor-pointer"
                    />
                </Link> */}
                {/* <Link to="/" onClick={() => window.scrollTo(0, 0)}>
                    <div className="h-16 sm:h-24 lg:h-24 mx-8 flex items-center drop-shadow-md cursor-pointer">
                        <div className="flex flex-col items-start">
                            <div className="flex items-center space-x-1">
                                <span className="text-2xl sm:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent">
                                    JYOTINAY
                                </span>
                                <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                            </div>
                            <span className="text-xs sm:text-sm lg:text-base font-mono text-gray-600 tracking-wider -mt-1">
                                ANALYTICS
                            </span>
                        </div>
                    </div>
                </Link> */}
                <Link to="/" onClick={() => window.scrollTo(0, 0)} className="cursor-pointer group">
                    <div className="h-16 sm:h-24 lg:h-24 mx-8 flex items-center">
                        <div className="flex items-center space-x-4">
                            {/* Sophisticated Data Visualization Icon */}
                            <div className="relative">
                                <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 bg-gradient-to-br from-blue-600 via-indigo-700 to-slate-800 rounded-lg shadow-xl flex items-center justify-center transform group-hover:scale-105 transition-all duration-300">
                                    {/* Abstract data visualization pattern */}
                                    <div className="relative w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8">
                                        {/* Rising bars representing analytics */}
                                        <div className="absolute bottom-0 left-0 w-1 h-3 bg-white bg-opacity-90 rounded-t"></div>
                                        <div className="absolute bottom-0 left-1.5 w-1 h-4 bg-white bg-opacity-75 rounded-t"></div>
                                        <div className="absolute bottom-0 left-3 w-1 h-5 bg-white rounded-t"></div>
                                        <div className="absolute bottom-0 left-4.5 w-1 h-2 bg-white bg-opacity-80 rounded-t"></div>

                                        {/* Connecting line representing trends */}
                                        <div className="absolute top-1 left-0 w-6 h-px bg-gradient-to-r from-white to-transparent opacity-60"></div>

                                        {/* Data point dots */}
                                        <div className="absolute top-2 right-1 w-1 h-1 bg-white rounded-full opacity-80"></div>
                                        <div className="absolute top-0.5 right-3 w-1 h-1 bg-white rounded-full"></div>
                                    </div>

                                    {/* Subtle glow effect */}
                                    <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-transparent opacity-20 rounded-lg"></div>
                                </div>
                            </div>

                            {/* Premium Typography */}
                            <div className="flex flex-col">
                                {/* Main Brand Name */}
                                <div className="flex items-baseline space-x-1">
                                    <span className="text-2xl sm:text-3xl lg:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-slate-800 via-blue-800 to-slate-900 tracking-tight">
                                        JYOTINAY
                                    </span>
                                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mb-1 opacity-80"></div>
                                </div>

                                {/* Elegant Tagline */}
                                <div className="flex items-center space-x-2 -mt-1">
                                    <span className="text-xs sm:text-sm lg:text-base font-medium text-slate-600 tracking-widest uppercase">
                                        Analytics & Intelligence
                                    </span>
                                    <div className="hidden sm:block w-8 h-px bg-gradient-to-r from-blue-300 to-transparent"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>

                {/* <div ref={menuRef}> */}
                {/* Hamburger menu button */}
                <button
                    className="block lg:hidden text-gray-600 hover:text-gray-800 text-3xl mx-8 transition-colors"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    &#9776;
                </button>

                {/* Navigation links */}
                <div
                    className={`lg:flex lg:items-center lg:space-x-8 text-xl text-gray-700 ${isMenuOpen
                        ? 'absolute top-full right-8 bg-white bg-opacity-95 shadow-xl rounded-lg w-48 flex flex-col items-start p-4 z-50 mt-2'
                        : 'hidden lg:block'
                        }`}
                >
                    {/* About - assume it’s on homepage */}
                    <Link
                        to="/about"
                        // onClick={() => {
                        //     <Link to="/services/contact" />
                        // }}
                        onClick={() => setIsMenuOpen(false)}
                        className="py-2 px-4 hover:bg-gray-100 rounded-lg w-full text-left transition-colors"
                    >
                        About
                    </Link>

                    {/* Contact - assume it’s on homepage */}
                    <Link
                        to="/contact"
                        // onClick={() => {
                        //     <Link to="/services/contact" />
                        // }}
                        onClick={() => setIsMenuOpen(false)}
                        className="py-2 px-4 hover:bg-gray-100 rounded-lg w-full text-left transition-colors"
                    >
                        Contact
                    </Link>
                    
                {/* </div> */}

                    {/* Services dropdown */}
                    <div className="relative w-full md:w-auto" ref={servicesRef}>
                        <button
                            onClick={() => setIsServicesOpen(!isServicesOpen)}
                            className="w-full flex justify-between items-center px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md md:inline-block md:w-auto md:hover:bg-transparent md:hover:text-blue-600"
                        >
                            Services
                        </button>

                        {isServicesOpen && (
                            <ul
                                className="mt-5 md:absolute md:left-[-45%] md:top-full bg-white border rounded-md shadow-lg z-50 w-full md:w-56"
                            >
                                <li>
                                    <Link
                                        to="/services/data-analytics"
                                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-left"
                                        onClick={() => {
                                            setIsServicesOpen(false)
                                            setIsMenuOpen(false)
                                        }
                                        } // close menu on click
                                    >
                                        Data Strategy Consulting
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/services/business-intelligence"
                                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-left"
                                        onClick={() => {
                                            setIsServicesOpen(false)
                                            setIsMenuOpen(false)
                                        }
                                        }
                                    >
                                        Business Intelligence
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/services/ai-and-ml"
                                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-left"
                                        onClick={() => {
                                            setIsServicesOpen(false)
                                            setIsMenuOpen(false)
                                        }
                                        }
                                    >
                                        AI & Machine Learning
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/services/kpi-dashboarding"
                                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-left"
                                        onClick={() => {
                                            setIsServicesOpen(false)
                                            setIsMenuOpen(false)
                                        }
                                        }
                                    >
                                        KPI Dashboarding
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/services/project-management"
                                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-left"
                                        onClick={() => {
                                            setIsServicesOpen(false)
                                            setIsMenuOpen(false)
                                        }
                                        }
                                    >
                                        Project Management
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/services/website-development"
                                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-left"
                                        onClick={() => {
                                            setIsServicesOpen(false)
                                            setIsMenuOpen(false)
                                        }
                                        }
                                    >
                                        Website Development
                                    </Link>
                                </li>
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
